export default __webpack_public_path__ + "static/media/photo-desktop.3c3b0e84.jpeg";